export default "__VITE_ASSET__ea646552__$_?component__"